import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { mockUserImages } from "@/components/user/mock/mockUserImages";
import { cn } from "@/lib/utils";

interface UploadImageDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onUpload: (image: string) => void;
	selectedImg?: string | null;
}

export const UploadImageDialog = ({
	open,
	onOpenChange,
	onUpload,
	selectedImg,
}: UploadImageDialogProps) => {
	const [selectedImage, setSelectedImage] = useState<string | null>(null);

	useEffect(() => {
		setSelectedImage(selectedImg || null);
	}, [selectedImg]);

	const handleUpload = () => {
		if (selectedImage) {
			onUpload(selectedImage);
			onOpenChange(false);
		}
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Select an Avatar</DialogTitle>
					<DialogDescription>Choose an avatar from the list</DialogDescription>
				</DialogHeader>

				<div className="flex flex-wrap gap-2 overflow-x-auto p-2">
					{mockUserImages.map((img) => (
						<img
							key={img.imageId}
							src={img.imageSrc}
							alt="Default Avatar"
							className={cn(
								"w-16 h-16 rounded-full cursor-pointer border border-transparent",
								selectedImage === img.imageSrc && "border-gold",
							)}
							onClick={() => setSelectedImage(img.imageSrc)}
							onKeyDown={() => setSelectedImage(img.imageSrc)}
						/>
					))}
				</div>

				{selectedImage && (
					<div className="flex flex-col items-center mt-4">
						<img
							src={selectedImage}
							alt="Selected Avatar"
							className="w-24 h-24 rounded-full"
						/>
					</div>
				)}

				<DialogFooter>
					<Button variant="outline" onClick={() => onOpenChange(false)}>
						Cancel
					</Button>
					<Button
						variant="outline"
						onClick={handleUpload}
						disabled={!selectedImage}
					>
						Confirm
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
